import { Component, inject, input, InputSignal } from '@angular/core';
import { IdService } from '../../services/id.service';

@Component({
  selector: 'td-wb-analytics-context',
  template: '<ng-content />',
  host: {
    '[attr.aria-hidden]': 'hidden',
    '[class.td-wb-vh]': 'visuallyHidden',
    '[attr.id]': 'id',
    '[attr.data-td-wb-analytics-context-id]': 'analyticsContext()'
  }
})
export class AnalyticsContextComponent {
  private readonly idService = inject(IdService);
  readonly analyticsContext: InputSignal<string | undefined> = input<string | undefined>(undefined);

  hidden: boolean = true;
  visuallyHidden: boolean = true;

  id: string = this.idService.generateNamespaceSequentialId('td-wb-analytics-context');
}
